import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './AppStore';
import './assets/css/general/Index.css';
import { createTheme as createThemeMantine, MantineProvider } from '@mantine/core';

const mantineTheme = createThemeMantine({
  /** Put your mantine theme override here */
});

// Only apply theme if user is authenticated
const currentUser = localStorage.getItem('user');
if (currentUser) {
  const storedTheme = localStorage.getItem('app-theme') as 'light' | 'dark' | 'auto' | null;
  if (storedTheme && storedTheme !== 'auto') {
    document.body.classList.add(`theme-${storedTheme}`);
  } else if (storedTheme === 'auto') {
    // For 'auto', check system preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const systemTheme = mediaQuery.matches ? 'dark' : 'light';
    document.body.classList.add(`theme-${systemTheme}`);
  } else {
    document.body.classList.add('theme-light');
  }
} else {
  // Unauthenticated users: remove any theme classes
  document.body.classList.remove('theme-light', 'theme-dark');
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#5f633f',
      contrastText: '#fff',
      dark: '#3b3e26',
      light: '#8c8f63',
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <MantineProvider theme={mantineTheme}>
      <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
      </BrowserRouter>
    </MantineProvider>
  </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// ReportWebVitals(console.log);